import { useEffect, useRef, useState, useCallback } from "react";
import { FiltroGlobal, useFiltrosAtivos } from "../../components/FiltrosGlobais";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator, ColumnComponent, ColumnDefinition } from "tabulator-tables";
import { RequestMethod } from "../modules/services/core/_enums";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import moment from "moment";
import { useAuth } from "../modules/auth";
import { useLocation } from "react-router-dom";

// Estilos globais
const styles = `
    .tabulator-row.selected {
        background-color: #e6f3ff !important;
    }

    .tabulator-row:hover {
        background-color: #f5f5f5 !important;
    }

    .tabulator-cell a {
        color: #2185d0;
        text-decoration: none;
    }

    .tabulator-cell a:hover {
        color: #1678c2;
        text-decoration: underline;
    }

    .tabulator-footer {
        background-color: #f8f9fa !important;
        border-top: 2px solid #dee2e6 !important;
        padding: 8px 15px !important;
    }

    .tabulator-paginator {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }

    .tabulator-footer #footer {
        color: #666;
        font-weight: 500;
    }

    .tabulator-pages {
        margin: 0 10px !important;
    }

    .tabulator-page {
        border: 1px solid #dee2e6 !important;
        background-color: white !important;
        color: #666 !important;
        border-radius: 4px !important;
        margin: 0 2px !important;
        padding: 5px 10px !important;
    }

    .tabulator-page.active {
        background-color: #0d6efd !important;
        color: white !important;
        border-color: #0d6efd !important;
    }

    .tabulator-page:not(.disabled):hover {
        background-color: #e9ecef !important;
        color: #0d6efd !important;
        border-color: #dee2e6 !important;
    }

    .tabulator-page-size {
        border: 1px solid #dee2e6 !important;
        border-radius: 4px !important;
        padding: 4px 8px !important;
        margin-right: 10px !important;
        color: #666 !important;
        background-color: white !important;
    }

    .tabulator-page-size:focus {
        outline: none !important;
        border-color: #0d6efd !important;
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25) !important;
    }

    .tabulator-footer .tabulator-paginator label {
        margin-right: 8px !important;
        color: #666 !important;
        font-weight: 500 !important;
    }

    .sidebar-config {
        position: fixed;
        right: 0;
        top: 0;
        width: 350px;
        height: 100vh;
        background: #f8f9fa;
        padding: 20px;
        box-shadow: -2px 0 5px rgba(0,0,0,0.1);
        transition: 0.3s;
        z-index: 1000;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
    }

    .sidebar-config h4 {
        margin-bottom: 20px;
        color: #333 !important;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .sidebar-config .ui.button {
        margin-top: 20px;
    }

    .suggestion-list {
        background: white;
        border: 1px solid #ddd;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .suggestion-item {
        padding: 8px 12px;
        cursor: pointer;
    }

    .suggestion-item:hover {
        background-color: #f5f5f5;
    }

    .filter-input {
        width: 100%;
        padding: 6px;
        border: 1px solid #ddd;
        border-radius: 4px;
    }
`;

// Adiciona os estilos ao documento
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

// Interface para os dados da visão geral
interface IVisaoGeral {
    Alerta: string | null;
    Alteracao: string;
    Assunto: string;
    Chamado: string;
    Cor: string;
    Descricao: string;
    Fechamento: string | null;
    IdWorkFlow: number;
    Inclusao: string;
    Local: string | null;
    LocalDescricao: string | null;
    Movel: number;
    Nome: string;
    Organization: string;
    Origem: string;
    Requisitante: string;
    Responsavel: string;
    Situacao: number;
    Status: string;
    TempoDecorrido: number;
    TimeToResolve_minutes: number;
    TotalInteracoes: number;
    UltimaAtualizacao: string;
    UltimaInteracao: string | null;
    UltimoComentarioUsuario: string | null;
}

// Interface para Organização
interface Organization {
    OrganizationId: number;
    OrganizationName: string;
    Idcorporacao: number;
    CorporationName: string;
}

interface Corporation {
    id: number;
    name: string;
}

const MenuVisaoGeral: React.FC = () => {
    const tableRef = useRef<HTMLDivElement>(null);
    const configTableRef = useRef<HTMLDivElement>(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const mainTableRef = useRef<any>(null);
    const configTableRefInstance = useRef<any>(null);
    const dataSetNamePBI = getDataSetNamePBI();

    const httpClient = useHttpClient();
    const [listaVisaoGeral, setListaVisaoGeral] = useState<IVisaoGeral[]>([]);
    const [totalRegistros, setTotalRegistros] = useState<number>(0);
    const [registrosFiltrados, setRegistrosFiltrados] = useState<number>(0);
    const [colunasConfiguradas, setColunasConfiguradas] = useState<any[]>([]);

    // ✅ NOVO - Hook para acessar filtros globais
    const { selectedOrganizations, isInitialized, selectedCorporation, availableCorporations } = useFiltrosAtivos();
    const isVwco = availableCorporations.find(c => c.id === selectedCorporation)?.name === "VWCO";
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    // Usar refs para controle de estado que não precisa causar re-render
    const componentInitialized = useRef(false); // ✅ Renomeado para evitar conflito
    const urlFiltersApplied = useRef(false);
    const isLoadingData = useRef(false); // Previne chamadas simultâneas
    const pendingUrlFilters = useRef<{
        type?: string;
        situacao?: string;
        orgParam?: string;
    } | null>(null);

    // Novo estado para armazenar os filtros ativos
    const [activeFilters, setActiveFilters] = useState<Record<string, any>>({});

    const { auth } = useAuth();
    const user = auth?.User;
    const emailUsuario = user?.Email;
    const location = useLocation();

    const SCREEN_CODE_VISAO_GERAL = "VISAO_GERAL";
    const cacheUserId = auth?.User?.IdUsuario != null ? parseInt(String(auth.User.IdUsuario), 10) || 0 : 0;

    const extractCacheJson = useCallback((response: any): any => {
        const container = response?.payload ?? response?.data ?? response;
        if (container == null) return null;
        const dataStr = typeof container === "string" ? container : (container?.Data ?? container?.data);
        if (typeof dataStr === "string") {
            try {
                return JSON.parse(dataStr);
            } catch {
                return null;
            }
        }
        if (typeof container === "object" && container !== null) return container;
        return null;
    }, []);

    const saveTableColumnsCache = useCallback(
        async (columnsVisibility: Record<string, boolean>, columnsOrder: string[]) => {
            if (cacheUserId === 0) return;
            try {
                let current: any = {};
                try {
                    const response = await httpClient.request({
                        method: RequestMethod.GET,
                        endpoint: `/api/Cache/${SCREEN_CODE_VISAO_GERAL}?userId=${cacheUserId}`,
                    });
                    current = extractCacheJson(response) || {};
                } catch {
                    // ignore
                }
                const next = { ...current, columnsVisibility, columnsOrder };
                await httpClient.request({
                    method: RequestMethod.POST,
                    endpoint: "/api/Cache",
                    data: {
                        UserId: cacheUserId,
                        ScreenCode: SCREEN_CODE_VISAO_GERAL,
                        Data: JSON.stringify(next),
                    },
                });
            } catch (e) {
                console.error("Erro ao salvar cache de colunas (VISAO_GERAL).", e);
            }
        },
        [httpClient, extractCacheJson, cacheUserId]
    );

    // ❌ REMOVIDO - userId agora é gerenciado pelo FiltrosProvider global

    // Função para salvar os filtros no localStorage
    const saveFiltersToStorage = useCallback((filters: Record<string, any>) => {
        localStorage.setItem('menuVisaoGeralFilters', JSON.stringify(filters));
    }, []);

    // Função para carregar os filtros do localStorage
    const loadFiltersFromStorage = useCallback(() => {
        const savedFilters = localStorage.getItem('menuVisaoGeralFilters');
        return savedFilters ? JSON.parse(savedFilters) : null;
    }, []);

    // Função para verificar se é um refresh da página ou primeira visita
    const isPageRefresh = useCallback(() => {
        // Verifica se é refresh direto (Ctrl+F5, F5, etc.)
        const isReload = window.performance?.navigation?.type === 1 ||
            window.performance?.getEntriesByType?.('navigation')?.some((nav: any) => nav.type === 'reload');

        // Verifica se a página foi carregada com parâmetros na URL (primeira visita com parâmetros)
        const hasUrlParams = window.location.search.includes('org=') || window.location.search.includes('type=') || window.location.search.includes('situacao=');

        // Se tem parâmetros na URL, sempre limpa o localStorage para evitar conflitos
        if (hasUrlParams) {
            console.log("Detectados parâmetros na URL, limpando localStorage para evitar conflitos");
            localStorage.removeItem('menuVisaoGeralFilters');
            return true;
        }

        return isReload;
    }, []);

    // Função para aplicar os filtros salvos na tabela
    const applyStoredFilters = useCallback(() => {
        if (!mainTableRef.current || isPageRefresh()) return;

        // Se há filtros pendentes da URL, não aplica os salvos para evitar conflitos
        if (pendingUrlFilters.current) {
            console.log("Filtros da URL pendentes, ignorando filtros salvos para evitar conflitos");
            return;
        }

        const savedFilters = loadFiltersFromStorage();
        if (!savedFilters) return;

        console.log("Aplicando filtros salvos:", savedFilters);

        const columns = mainTableRef.current.getColumns();

        columns.forEach((column: ColumnComponent) => {
            const field = column.getField();
            if (savedFilters[field]) {
                column.setHeaderFilterValue(savedFilters[field]);
            }
        });

        // REMOVIDO: Não reaplica organizações aqui para evitar loops
        // As organizações devem ser controladas apenas pela lógica principal
    }, [loadFiltersFromStorage, isPageRefresh]);

    // Função para limpar os filtros salvos
    const clearStoredFilters = useCallback(() => {
        console.log("🧹 Limpando filtros salvos e resetando estado");
        localStorage.removeItem('menuVisaoGeralFilters');

        // Reset de todos os refs de controle
        urlFiltersApplied.current = false;
        pendingUrlFilters.current = null;
        isLoadingData.current = false; // Reset do estado de loading

        // ✅ NOVO - organizações são gerenciadas globalmente, apenas reseta filtros locais
        setActiveFilters({});

        if (mainTableRef.current) {
            mainTableRef.current.clearHeaderFilter();
            mainTableRef.current.setData([]);
        }
    }, []);

    // Função auxiliar para resetar filtros
    const resetHeaderFilters = useCallback(() => {
        if (!mainTableRef.current) return;

        const columns = mainTableRef.current.getColumns();
        columns.forEach((column: any) => {
            const headerFilter = column.getHeaderFilterValue();
            if (headerFilter !== null && headerFilter !== undefined) {
                try {
                    column.setHeaderFilterValue('');
                } catch (e) {
                    console.error(`Erro ao limpar filtro da coluna ${column.getField()}:`, e);
                }
            }
        });
    }, []);

    // ❌ REMOVIDO - fetchUserId e fetchUserOrganizations agora são gerenciados pelo FiltrosProvider global

    // Função principal para obter visão geral (memoizada para evitar loops)
    const obterVisaoGeral = useCallback(async (orgs?: string[]) => {
        try {
            // Se não foram passadas organizações específicas, não usa fallback
            if (!orgs || orgs.length === 0) {
                console.log("⚠️ Nenhuma organização selecionada - limpando dados");
                setListaVisaoGeral([]);
                return;
            }

            // Previne múltiplas chamadas simultâneas
            if (isLoadingData.current) {
                console.log("🚫 Chamada bloqueada - dados já sendo carregados");
                return;
            }

            isLoadingData.current = true;
            console.log("📡 INÍCIO obterVisaoGeral com organizações:", orgs);

            const endpoint = "/Gerenciamento/PowerBI/ObterVisaoGeralByOrg";
            const queryParams = new URLSearchParams();

            if (dataSetNamePBI) {
                queryParams.append("datasetName", dataSetNamePBI);
            }

            // Adiciona as organizações selecionadas aos parâmetros
            orgs.forEach((org) => {
                queryParams.append("org", org);
            });

            const queryString = queryParams.toString();
            const fullUrl = `${endpoint}?${queryString}`;

            console.log("🌐 Requisitando dados do endpoint:", fullUrl);

            const response = await httpClient.request({
                method: RequestMethod.GET,
                endpoint: fullUrl,
            });

            if (response.success && response.payload) {
                console.log("✅ Total de dados recebidos:", response.payload.length);
                setListaVisaoGeral(response.payload);
            } else {
                console.log("❌ Resposta sem dados:", response);
                setListaVisaoGeral([]);
            }
        } catch (error) {
            console.error("❌ Erro ao obter visão geral:", error);
            setListaVisaoGeral([]);
        } finally {
            isLoadingData.current = false;
            console.log("🏁 Finalizando obterVisaoGeral");
        }
    }, [httpClient, dataSetNamePBI]);

    // ✅ NOVO - Função simplificada para aplicar apenas filtros de tabela da URL
    const applyUrlFilters = useCallback(() => {
        const params = new URLSearchParams(window.location.search);
        const type = params.get('type');
        const situacao = params.get('situacao');

        console.log("🔍 Parâmetros detectados na URL:", { type, situacao, url: window.location.search });

        if (type || situacao) {
            // Salva os filtros para aplicar depois na tabela
            pendingUrlFilters.current = {
                type: type || undefined,
                situacao: situacao || undefined
            };
            console.log("💾 Filtros salvos para aplicação posterior:", pendingUrlFilters.current);
        }

        // ✅ Filtros de organização são gerenciados automaticamente pelo FiltrosProvider global
    }, []);

    // Aplicar filtros pendentes da URL após carregar dados
    const applyPendingUrlFilters = useCallback(() => {
        if (!mainTableRef.current || !pendingUrlFilters.current || urlFiltersApplied.current) {
            console.log("🚫 Não aplicando filtros da URL:", {
                hasTable: !!mainTableRef.current,
                hasPendingFilters: !!pendingUrlFilters.current,
                alreadyApplied: urlFiltersApplied.current
            });
            return;
        }

        console.log("🎯 Aplicando filtros da URL após carregamento dos dados:", pendingUrlFilters.current);

        // Aguarda o tabulator estar completamente renderizado
        setTimeout(() => {
            try {
                const { type, situacao } = pendingUrlFilters.current!;

                // Aplicar filtro de tipo (Gateway/Ativo)
                if (type) {
                    const origemColumn = mainTableRef.current?.getColumn("Origem");
                    if (origemColumn) {
                        // ✅ CORRIGIDO - Mapeamento baseado nos dados reais da API
                        let origemValue: string;
                        if (type.toLowerCase() === "gateway") {
                            // Os dados vêm como "gateway" (g minúsculo)
                            origemValue = "gateway";
                        } else if (type.toLowerCase() === "ativo") {
                            // Os dados vêm como "Ativo" (A maiúsculo)
                            origemValue = "Ativo";
                        } else {
                            // Para outros valores, usar o valor exato da URL
                            origemValue = type;
                        }

                        console.log("📋 Aplicando filtro de Origem:", {
                            urlValue: type,
                            mappedValue: origemValue,
                            filterArray: [origemValue]
                        });

                        // Para filtro multiselect, usar array com um item
                        origemColumn.setHeaderFilterValue([origemValue]);
                    } else {
                        console.error("❌ Coluna 'Origem' não encontrada");
                    }
                }

                // Aplicar filtro de situação (0/1)
                if (situacao !== null && situacao !== undefined) {
                    const situacaoColumn = mainTableRef.current?.getColumn("Situacao");
                    if (situacaoColumn) {
                        console.log("📋 Aplicando filtro de Situacao:", {
                            urlValue: situacao,
                            filterValue: situacao
                        });
                        situacaoColumn.setHeaderFilterValue(situacao);
                    } else {
                        console.error("❌ Coluna 'Situacao' não encontrada");
                    }
                }

                // Marcar como aplicado e limpar filtros pendentes
                urlFiltersApplied.current = true;
                pendingUrlFilters.current = null;
                console.log("✅ Filtros da URL aplicados com sucesso");
            } catch (error) {
                console.error("❌ Erro ao aplicar filtros da URL:", error);
                urlFiltersApplied.current = true;
                pendingUrlFilters.current = null;
            }
        }, 300);
    }, []);

    // Estado para controlar última requisição e evitar loops
    const lastOrgsRef = useRef<string>('');

    // ✅ NOVO - useEffect para processar filtros da URL na inicialização
    useEffect(() => {
        if (!componentInitialized.current) {
            console.log('🔧 Inicialização do componente - processando filtros da URL');
            applyUrlFilters();
            componentInitialized.current = true;
        }
    }, []); // Executado apenas uma vez na inicialização

    // ✅ NOVO - useEffect simplificado para monitorar mudanças nos filtros globais (sem dependência circular)
    useEffect(() => {
        const currentOrgsString = JSON.stringify(selectedOrganizations.sort());
        console.log('MenuVisaoGeral - useEffect disparado:', { selectedOrganizations, isInitialized, lastOrgs: lastOrgsRef.current, currentOrgs: currentOrgsString });

        // Evita chamadas duplicadas para as mesmas organizações
        if (lastOrgsRef.current === currentOrgsString) {
            console.log('🚫 Ignorando - mesmas organizações já carregadas');
            return;
        }

        if (isInitialized && selectedOrganizations.length > 0) {
            console.log('🔄 Carregando dados para organizações:', selectedOrganizations);
            lastOrgsRef.current = currentOrgsString;
            obterVisaoGeral(selectedOrganizations);
        } else if (isInitialized) {
            console.log('⚠️ Resetando dados - nenhuma organização selecionada');
            lastOrgsRef.current = '';
            setListaVisaoGeral([]);
        }
    }, [selectedOrganizations, isInitialized]); // ✅ Removida dependência obterVisaoGeral

    // Editor personalizado para filtro de duração
    const durationFilterEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
        const container = document.createElement("span");

        const start = document.createElement("input");
        start.setAttribute("type", "number");
        start.setAttribute("placeholder", "Min");
        start.style.padding = "4px";
        start.style.width = "32%";

        const end = start.cloneNode() as HTMLInputElement;
        end.setAttribute("placeholder", "Max");

        const lista = document.createElement('select');
        lista.style.width = "32%";
        lista.style.padding = "2px";

        ['Minutos', 'Horas', 'Dias', 'Meses'].forEach(opt => {
            const option = document.createElement('option');
            option.value = opt.toLowerCase();
            option.text = opt;
            lista.appendChild(option);
        });

        const buildValues = () => {
            success({
                start: start.value,
                end: end.value,
                unit: lista.value
            });
        };

        [start, end, lista].forEach(el => {
            el.addEventListener("change", buildValues);
            el.addEventListener("blur", buildValues);
        });

        container.appendChild(start);
        container.appendChild(end);
        container.appendChild(lista);

        return container;
    };

    // Editor personalizado para filtro de data
    const dateEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
        const container = document.createElement("span");

        // Criar inputs de data
        const date2 = document.createElement("input");
        date2.setAttribute("type", "date");
        date2.style.padding = "3px";
        date2.style.width = "50%";
        date2.style.fontSize = "12px";
        date2.style.boxSizing = "border-box";

        const date1 = date2.cloneNode() as HTMLInputElement;

        // Configurar datas iniciais
        const hoje = new Date();
        date2.value = hoje.toISOString().split('T')[0];

        const dataAnterior = new Date();
        dataAnterior.setFullYear(dataAnterior.getFullYear() - 1);
        date1.value = dataAnterior.toISOString().split('T')[0];

        const buildValues = () => {
            success({
                date1: date1.value,
                date2: date2.value,
            });
        };

        const keypress = (e: KeyboardEvent) => {
            if (e.key === "Enter") {
                buildValues();
            }
            if (e.key === "Escape") {
                cancel();
            }
        };

        // Adicionar event listeners
        [date1, date2].forEach(el => {
            el.addEventListener("change", buildValues);
            el.addEventListener("blur", buildValues);
            el.addEventListener("keydown", keypress);
        });

        container.appendChild(date1);
        container.appendChild(date2);

        return container;
    };

    // Função de filtro para datas
    const dateFilterFunction = (headerValue: any, rowValue: any) => {
        // Se não há filtro definido, mostra todos os registros
        if (!headerValue || (!headerValue.date1 && !headerValue.date2)) return true;

        // Se o valor da linha é vazio/nulo, não mostra
        if (!rowValue) return false;

        // Função para normalizar qualquer formato de data para Date
        const normalizeDate = (dateValue: string | Date) => {
            // Se já é um objeto Date, retorna diretamente
            if (dateValue instanceof Date) return dateValue;

            // Tenta parsear formato DD/MM/YYYY HH:mm:ss
            const dateTimeMatch = String(dateValue).match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
            if (dateTimeMatch) {
                const [_, day, month, year, hours, minutes, seconds] = dateTimeMatch;
                return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    parseInt(hours),
                    parseInt(minutes),
                    parseInt(seconds)
                );
            }

            // Tenta parsear como ISO
            const date = new Date(dateValue);
            return isNaN(date.getTime()) ? null : date;
        };

        // Normaliza a data da linha
        const rowDate = normalizeDate(rowValue);
        if (!rowDate) return false;

        // Normaliza as datas do filtro
        const startDate = headerValue.date1 ? new Date(headerValue.date1) : null;
        const endDate = headerValue.date2 ? new Date(headerValue.date2) : null;

        // Ajusta o endDate para incluir o dia inteiro
        if (endDate) {
            endDate.setDate(endDate.getDate() + 1);
        }

        // Se não há datas no filtro, mostra tudo
        if (!startDate && !endDate) return true;

        // Ajusta o range do filtro
        const startOfDay = startDate ? new Date(startDate) : null;
        const endOfDay = endDate ? new Date(endDate) : null;

        if (startOfDay) startOfDay.setHours(0, 0, 0, 0);
        if (endOfDay) endOfDay.setHours(23, 59, 59, 999);

        // Caso 1: Mesma data em ambos os campos (filtro para um único dia)
        if (startDate && endDate && startDate.toDateString() === endDate.toDateString()) {
            return rowDate >= startOfDay! && rowDate <= endOfDay!;
        }

        // Caso 2: Apenas data inicial definida
        if (startDate && !endDate) {
            return rowDate >= startOfDay!;
        }

        // Caso 3: Apenas data final definida
        if (!startDate && endDate) {
            return rowDate <= endOfDay!;
        }

        // Caso 4: Intervalo de datas definido
        if (startDate && endDate) {
            return rowDate >= startOfDay! && rowDate <= endOfDay!;
        }

        return true;
    };

    const getBaseColumns = (): ColumnDefinition[] => [
        {
            title: "",
            field: "Situacao",
            width: 60,
            hozAlign: "center",
            headerSort: false,
            frozen: true,
            resizable: false,
            tooltip: "Alerta aberto ou fechado",
            formatter: function (cell) {
                const value = cell.getValue();
                if (value === 1) {
                    return '<i class="ui large green check icon" style="padding: 2px;" title="Fechado"></i>';
                } else {
                    return '<i class="ui large grey clock icon" style="padding: 2px;" title="Aberto"></i>';
                }
            },
            headerFilter: "list",
            headerFilterParams: {
                values: {
                    "0": "Abertos",
                    "1": "Fechados"
                },
                clearable: true
            },
            headerFilterFunc: function (headerValue, rowValue, rowData, filterParams) {
                if (headerValue === "" || headerValue === null || headerValue === undefined) return true;
                return rowValue.toString() === headerValue.toString();
            }
        },
        {
            title: "",
            field: "OrigemIcone",
            formatter: function (cell) {
                const data = cell.getData();
                const origem = data.Origem;
                const local = data.Local;

                if (origem === "Gateway") {
                    if (local && local.includes("Frota")) {
                        return `<img src="https://portal.taggen.net/assets/imagens/green-car-48px.png" alt="Frota Icon" style="width: 24px;">`;
                    } else {
                        return `<img src="https://portal.taggen.net/assets/imagens/green-building-48px.png" alt="Gateway Icon" style="width: 24px;">`;
                    }
                } else if (origem === "Ativo") {
                    return `<img src="https://portal.taggen.net/assets/imagens/Beacon_48px.png" alt="Ativo Icon" style="width: 24px;">`;
                }
                return "";
            },
            hozAlign: "center",
            headerSort: false,
            frozen: true
        },
        {
            title: "Status",
            field: "Status",
            formatter: function (cell) {
                const data = cell.getData();
                const cor = data.Cor;
                let status = '<i class="ui large icon info circle" style="color:' + cor + '; padding: 2px"></i>';

                switch (data.Status) {
                    case "Atenção":
                        status = '<i class="ui large icon exclamation circle" style="color:' + cor + '; padding: 2px"></i>';
                        break;
                    case "Baixo":
                    case "Médio":
                    case "Alto":
                    case "Crítico":
                        status = '<i class="ui large icon exclamation triangle" style="color:' + cor + '; padding: 2px"></i>';
                        break;
                }

                return status;
            },
            frozen: true,
            hozAlign: "center",
            resizable: false,
            headerSort: false,
            tooltip: function (e, cell) {
                const data = cell.getData();
                return `Nivel: ${data.Status}`;
            }
        },
        {
            title: "Alerta",
            field: "Alerta",
            sorter: "string",
            frozen: true
        },
        {
            title: "Organização",
            field: "Organization",
            headerFilter: "list",
            headerFilterParams: {
                values: true, // Será atualizado no evento dataLoaded
                multiselect: true,
                clearable: true
            },
            headerFilterPlaceholder: "Selecione...",
            headerFilterFunc: function (headerValue: any, rowValue: any) {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            }
        },
        {
            title: "Local",
            field: "Local",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
                values: true, // Será atualizado no evento dataLoaded
                multiselect: true,
                clearable: true
            },
            headerFilterPlaceholder: "Selecione...",
            headerFilterFunc: function (headerValue: any, rowValue: any) {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            },
            formatter: function (cell) {
                const value = cell.getValue();
                return value || '<div style="margin: auto; width: 60%; text-align: center;">-</div>';
            }
        },
        {
            title: "Descrição do Local",
            field: "LocalDescricao",
            headerFilter: "input",
            headerFilterPlaceholder: "Digite..."
        },
        {
            title: isVwco ? "Prisma/Gateway" : "Ativo/Gateway",
            field: "Origem",
            sorter: "string",
            formatter: function (cell) {
                const data = cell.getValue();
                if (data?.toLowerCase() === "gateway") {
                    return `<span><i class="ui hdd outline icon" style="padding-right: 3px"></i>Gateway</span>`;
                } else if (data === "Ativo") {
                    const label = isVwco ? "Prisma" : "Ativo";
                    return `<span><i class="ui tag icon" style="padding-right: 3px"></i>${label}</span>`;
                }
                return data || "-";
            },
            headerFilter: "list",
            headerFilterParams: {
                values: [
                    { label: "gateway", value: "gateway" },
                    { label: isVwco ? "Prisma" : "Ativo", value: "Ativo" }
                ],
                multiselect: true,
                clearable: true
            },
            headerFilterFunc: function (headerValue: any, rowValue: any) {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            }
        },
        {
            field: "Nome",
            title: isVwco ? "Nome Prisma/Gateway" : "Nome Ativo/Gateway",
            width: 200,
            minWidth: 180,
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
                values: true,
                multiselect: true,
                clearable: true,
                sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
            formatter: function (cell) {
                const data = cell.getData();
                const icone = data.Movel ? "car" : "building";
                if (data.Origem.toLowerCase() === "gateway") {
                    const linkLocal = `/detalhes-do-gateway?gateway=${data.Nome}`;
                    return `<a href="${linkLocal}"><i class="ui icon external alternate" style="padding-right: 5px"></i><i class="ui ${icone} icon" style="padding-right: 3px"></i>${data.Nome}</a>`;
                } else {
                    const linkAtivo = `/detalhes-do-ativo?ativo=${data.Nome}`;
                    return `<a href="${linkAtivo}"><i class="ui icon external alternate"></i>${data.Nome}</a>`;
                }
            },
            tooltip: function (e, cell) {
                const data = cell.getData();
                return data.Movel ? "Gateway Móvel" : "Gateway Fixo";
            }
        },
        {
            field: "Descricao",
            title: isVwco ? "Descrição Prisma/Gateway" : "Descrição Ativo/Gateway",
            width: 200,
            minWidth: 180,
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
                values: true, // Será atualizado no evento dataLoaded
                multiselect: true,
                clearable: true,
                sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
            formatter: function (cell) {
                const value = cell.getValue();
                return value || '<div style="margin: auto; width: 60%; text-align: center;">-</div>';
            }
        },
        {
            field: "Chamado",
            title: "Chamado",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
                values: true, // Será atualizado no evento dataLoaded
                multiselect: true,
                clearable: true
            },
            headerFilterPlaceholder: "Selecione...",
            headerFilterFunc: function (headerValue: any, rowValue: any) {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            }
        },
        {
            field: "TotalInteracoes",
            title: "Interações",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: "Digite...",
            formatter: function (cell) {
                const data = cell.getData();
                const id = data.IdWorkFlow;
                const interacoes = cell.getValue();
                const baseStyle = "display: flex; align-items: center; justify-content: center; width: 100%; text-decoration: none;";
                const iconStyle = "margin: 0 2px;";

                if (data.Origem.toLowerCase() === "gateway") {
                    return `
                                    <a href="/chamado-gateway?var-IdWorkFlow=${id}" style="${baseStyle}">
                                        <i class="ui icon external alternate" style="${iconStyle}"></i>
                                        <i class="ui icon comments outline" style="${iconStyle}; color: gold;"></i>
                                        <span style="margin-left: 2px;">${interacoes}</span>
                                    </a>
                                `;
                } else {
                    return `
                                    <a href="/chamado-ativo?var-IdWorkFlow=${id}" style="${baseStyle}">
                                        <i class="ui icon external alternate" style="${iconStyle}"></i>
                                        <i class="ui icon comments outline" style="${iconStyle}; color: gold;"></i>
                                        <span style="margin-left: 2px;">${interacoes}</span>
                                    </a>
                                `;
                }
            },
            hozAlign: "center",
            resizable: false,
            headerSort: false,
            tooltip: "Interações",
            width: 120
        },
        {
            field: "UltimaInteracao",
            title: "Última interação",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
                const toTimestamp = (dateTimeStr: string) => {
                    const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                    if (match) {
                        const [_, day, month, year, hours, mins, secs] = match;
                        return new Date(
                            parseInt(year),
                            parseInt(month) - 1,
                            parseInt(day),
                            parseInt(hours),
                            parseInt(mins),
                            parseInt(secs)
                        ).getTime();
                    }

                    // Tenta formato ISO
                    const isoDate = new Date(dateTimeStr);
                    return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
                };

                const timeA = a ? toTimestamp(a) : 0;
                const timeB = b ? toTimestamp(b) : 0;
                return timeA - timeB;
            },
            formatter: (cell: any) => {
                const value = cell.getValue();
                if (!value) return " - ";

                // Se já está no formato correto, subtrai 3 horas
                if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                    const date = moment(value, "DD/MM/YYYY HH:mm:ss", true);
                    if (date.isValid()) {
                        return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                    }
                    return value;
                }

                // Para outros formatos (ISO, etc), subtrai 3 horas
                const date = moment(value);
                if (date.isValid()) {
                    return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                }

                return String(value);
            }
        },
        {
            field: "Inclusao",
            title: "Inclusão",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
                const toTimestamp = (dateTimeStr: string) => {
                    const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                    if (match) {
                        const [_, day, month, year, hours, mins, secs] = match;
                        return new Date(
                            parseInt(year),
                            parseInt(month) - 1,
                            parseInt(day),
                            parseInt(hours),
                            parseInt(mins),
                            parseInt(secs)
                        ).getTime();
                    }

                    // Tenta formato ISO
                    const isoDate = new Date(dateTimeStr);
                    return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
                };

                const timeA = a ? toTimestamp(a) : 0;
                const timeB = b ? toTimestamp(b) : 0;
                return timeA - timeB;
            },
            formatter: (cell: any) => {
                const value = cell.getValue();
                if (!value) return " - ";

                // Se já está no formato correto, subtrai 3 horas
                if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                    const date = moment(value, "DD/MM/YYYY HH:mm:ss", true);
                    if (date.isValid()) {
                        return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                    }
                    return value;
                }

                // Para outros formatos (ISO, etc), subtrai 3 horas
                const date = moment(value);
                if (date.isValid()) {
                    return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                }

                return String(value);
            }
        },
        {
            field: "UltimoComentarioUsuario",
            title: isVwco ? "Origem comentário" : "Comentado por...",
            headerFilter: "list",
            headerFilterParams: {
                values: true, // Será atualizado no evento dataLoaded
                multiselect: true,
                clearable: true
            },
            headerFilterPlaceholder: "Selecione...",
            headerFilterFunc: function (headerValue: any, rowValue: any) {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            },
            sorter: "string"
        },
        {
            field: "Assunto",
            title: "Assunto",
            width: 150,
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: "Digite...",
            resizable: true
        },
        {
            field: "Requisitante",
            title: "Criado por",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
                values: true, // Será atualizado no evento dataLoaded
                multiselect: true,
                clearable: true
            },
            headerFilterPlaceholder: "Selecione...",
            headerFilterFunc: function (headerValue: any, rowValue: any) {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            },
            resizable: true
        },
        {
            field: "Responsavel",
            title: "Responsável",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
                values: true, // Será atualizado no evento dataLoaded
                multiselect: true,
                clearable: true
            },
            headerFilterPlaceholder: "Selecione...",
            headerFilterFunc: function (headerValue: any, rowValue: any) {
                if (!headerValue || headerValue.length === 0) return true;
                if (Array.isArray(headerValue)) {
                    return headerValue.includes(rowValue);
                }
                return headerValue === rowValue;
            },
            resizable: true
        },
        {
            field: "UltimaAtualizacao",
            title: "Última Atualização",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
                const toTimestamp = (dateTimeStr: string) => {
                    const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                    if (match) {
                        const [_, day, month, year, hours, mins, secs] = match;
                        return new Date(
                            parseInt(year),
                            parseInt(month) - 1,
                            parseInt(day),
                            parseInt(hours),
                            parseInt(mins),
                            parseInt(secs)
                        ).getTime();
                    }

                    // Tenta formato ISO
                    const isoDate = new Date(dateTimeStr);
                    return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
                };

                const timeA = a ? toTimestamp(a) : 0;
                const timeB = b ? toTimestamp(b) : 0;
                return timeA - timeB;
            },
            formatter: (cell: any) => {
                const value = cell.getValue();
                if (!value) return " - ";

                // Se já está no formato correto, subtrai 3 horas
                if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                    const date = moment(value, "DD/MM/YYYY HH:mm:ss", true);
                    if (date.isValid()) {
                        return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                    }
                    return value;
                }

                // Para outros formatos (ISO, etc), subtrai 3 horas
                const date = moment(value);
                if (date.isValid()) {
                    return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                }

                return String(value);
            }
        },

        {
            field: "Fechamento",
            title: "Fechamento",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
                const toTimestamp = (dateTimeStr: string) => {
                    const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                    if (match) {
                        const [_, day, month, year, hours, mins, secs] = match;
                        return new Date(
                            parseInt(year),
                            parseInt(month) - 1,
                            parseInt(day),
                            parseInt(hours),
                            parseInt(mins),
                            parseInt(secs)
                        ).getTime();
                    }

                    // Tenta formato ISO
                    const isoDate = new Date(dateTimeStr);
                    return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
                };

                const timeA = a ? toTimestamp(a) : 0;
                const timeB = b ? toTimestamp(b) : 0;
                return timeA - timeB;
            },
            formatter: (cell: any) => {
                const value = cell.getValue();
                if (!value) return " - ";

                // Se já está no formato correto, subtrai 3 horas
                if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                    const date = moment(value, "DD/MM/YYYY HH:mm:ss", true);
                    if (date.isValid()) {
                        return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                    }
                    return value;
                }

                // Para outros formatos (ISO, etc), subtrai 3 horas
                const date = moment(value);
                if (date.isValid()) {
                    return date.subtract(3, 'hours').format("DD/MM/YYYY HH:mm:ss");
                }

                return String(value);
            }
        },
        {
            field: "TempoDecorrido",
            title: "Tempo decorrido",
            sorter: "number",
            headerFilter: durationFilterEditor,
            headerFilterFunc: dateFilterFunction,
            headerFilterLiveFilter: false,
            formatter: function (cell) {
                const totalMinutes = cell.getValue();
                const months = Math.floor(totalMinutes / (60 * 24 * 30));
                const days = Math.floor((totalMinutes % (60 * 24 * 30)) / (60 * 24));
                const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
                const minutes = totalMinutes % 60;

                const M = months ? `${months} M, ` : '';
                const D = days ? `${days} d, ` : '';
                const H = hours ? `${hours} h e ` : '';
                const I = `${minutes} min`;

                return `${M}${D}${H}${I}`;
            }
        }
    ];
    useEffect(() => {
        const carregarConfiguracaoColunas = async () => {
            // Encontra o nome da corporação atual
            const corpObj = availableCorporations.find(c => c.id === selectedCorporation);
            const corporationName = corpObj ? corpObj.name : "";

            if (corporationName) {
                try {
                    // Ajuste o endpoint conforme sua necessidade (ex: TABELA_VISAO_GERAL)
                    const endpoint = `/api/labels/VISAO_GERAL/${corporationName}`;
                    const response = await httpClient.request({
                        method: RequestMethod.GET,
                        endpoint: endpoint
                    });

                    if (response.success && response.payload) {
                        setColunasConfiguradas(response.payload);
                    }
                } catch (error) {
                    console.error("Erro ao carregar labels:", error);
                }
            }
        };

        if (isInitialized) {
            carregarConfiguracaoColunas();
        }
    }, [selectedCorporation, isInitialized]);


    // Efeito para inicializar tabela quando dados são carregados (sem dependências circulares)
    useEffect(() => {
        if (!tableRef.current || listaVisaoGeral.length === 0) return;

        if (mainTableRef.current) {
            mainTableRef.current.destroy();
            mainTableRef.current = null;
        }

        const shouldApplyFilters = !isPageRefresh();
        const footerContent = `<div id="footer">${listaVisaoGeral.length} Registros carregados (linhas filtradas: 0)</div>`;

        console.log("🎯 Inicializando Tabulator com", listaVisaoGeral.length, "registros");

        (async () => {
            // Buscar cache de colunas (visibilidade + ordem) – VISAO_GERAL
            let columnsVisibility: Record<string, boolean> = {};
            let columnsOrder: string[] = [];
            if (cacheUserId > 0) {
                try {
                    const cacheResponse = await httpClient.request({
                        method: RequestMethod.GET,
                        endpoint: `/api/Cache/${SCREEN_CODE_VISAO_GERAL}?userId=${cacheUserId}`,
                    });
                    const parsed = extractCacheJson(cacheResponse);
                    if (parsed && typeof parsed === "object") {
                        if (parsed.columnsVisibility && typeof parsed.columnsVisibility === "object") {
                            columnsVisibility = parsed.columnsVisibility;
                        }
                        if (Array.isArray(parsed.columnsOrder)) {
                            columnsOrder = parsed.columnsOrder;
                        }
                    }
                } catch (e) {
                    console.warn("Cache de colunas (VISAO_GERAL) indisponível, usando padrão.", e);
                }
            }

            const baseColumns = getBaseColumns();
            const columnsWithTitles = baseColumns.map(col => {
                const config = colunasConfiguradas.find(
                    c => c.Field && col.field && c.Field.toLowerCase() === col.field.toLowerCase()
                );
                if (config && config.Title) {
                    return { ...col, title: config.Title };
                }
                return col;
            });

            const byField: Record<string, ColumnDefinition> = {};
            columnsWithTitles.forEach(c => { if (c.field) byField[c.field] = c; });
            const orderedColumns: ColumnDefinition[] = columnsOrder.length
                ? [
                    ...columnsOrder.map(f => byField[f]).filter(Boolean),
                    ...columnsWithTitles.filter(c => c.field && !columnsOrder.includes(c.field)),
                ]
                : columnsWithTitles;
            const finalColumns: ColumnDefinition[] = orderedColumns.map(col => ({
                ...col,
                visible: col.field !== undefined ? (columnsVisibility[col.field] ?? true) : true,
            }));

            if (!tableRef.current) return;
            mainTableRef.current = new Tabulator(tableRef.current, {
                data: listaVisaoGeral,
                height: 650,
                layout: "fitDataFill",
                movableColumns: true,
                resizableColumnFit: true,
                columnHeaderVertAlign: "top",
                selectableRows: true,
                pagination: true,
                paginationMode: "local",
                paginationSize: 25,
                paginationSizeSelector: [10, 25, 50, 100],
                paginationButtonCount: 5,
                paginationCounter: "rows",
                footerElement: footerContent,
                locale: true,
                rowFormatter: function (row) {
                    var data = row.getData();
                    if (data.IdWorkFlow === null) {
                        row.getElement().style.display = "none";
                    }
                },
                langs: {
                    "default": {
                        pagination: {
                            first: "Primeira",
                            first_title: "Primeira Página",
                            last: "Última",
                            last_title: "Última Página",
                            prev: "Anterior",
                            prev_title: "Página Anterior",
                            next: "Próxima",
                            next_title: "Próxima Página",
                            page_size: " ",
                            page_title: "Mostrar Página",
                            all: "Todos",
                            counter: {
                                showing: "- Mostrando",
                                of: "de",
                                rows: "registros",
                                pages: "páginas"
                            }
                        }
                    }
                },
                initialSort: [
                    { column: "Situacao", dir: "asc" }
                ],
                columns: finalColumns
            });

            // Event listener para clicks nas linhas
            mainTableRef.current.on("rowClick", function (e: any, row: any) {
                const rows = mainTableRef.current.getRows();
                rows.forEach((r: any) => r.getElement().classList.remove("selected"));
                row.getElement().classList.add("selected");
            });

            // Evento para detectar quando a tabela está pronta
            mainTableRef.current.on("tableBuilt", function () {
                console.log("✅ Tabela construída e pronta para uso");

                // ✅ CORRIGIDO - Verifica se há filtro de situação específico na URL
                const hasSituacaoFilter = pendingUrlFilters.current?.situacao !== null &&
                    pendingUrlFilters.current?.situacao !== undefined;

                // Aplica o filtro inicial para mostrar apenas alertas abertos APENAS se não há filtro de situação na URL
                if (!hasSituacaoFilter) {
                    const situacaoColumn = mainTableRef.current.getColumn("Situacao");
                    if (situacaoColumn) {
                        console.log("🔧 Aplicando filtro inicial - apenas alertas abertos (sem filtro de situação na URL)");
                        situacaoColumn.setHeaderFilterValue("0");
                    }
                } else {
                    console.log("⚠️ Não aplicando filtro padrão - filtro de situação detectado na URL:", pendingUrlFilters.current?.situacao);
                }

                // Força uma atualização do footer inicial
                updateFooter(listaVisaoGeral.length, listaVisaoGeral.length);
            });

            // Evento dataLoaded para atualizar as opções dos filtros
            mainTableRef.current.on("dataLoaded", function (data: IVisaoGeral[]) {
                console.log("📊 Dados carregados na tabela:", data.length, "registros");
                if (data.length > 0) {
                    // Extrai valores únicos para cada coluna que usa filtro de lista
                    const uniqueOrganizations = Array.from(new Set(data.map((item: IVisaoGeral) => item.Organization)))
                        .filter(Boolean)
                        .sort();

                    const uniqueLocais = Array.from(new Set(data.map((item: IVisaoGeral) => item.Local)))
                        .filter(Boolean)
                        .sort();

                    const uniqueLocalDescricoes = Array.from(new Set(data.map((item: IVisaoGeral) => item.LocalDescricao)))
                        .filter(Boolean)
                        .sort();

                    const uniqueOrigens = Array.from(new Set(data.map((item: IVisaoGeral) => item.Origem)))
                        .filter(Boolean)
                        .sort();

                    const uniqueNomes = Array.from(new Set(data.map((item: IVisaoGeral) => item.Nome)))
                        .filter(Boolean)
                        .sort();

                    const uniqueDescricoes = Array.from(new Set(data.map((item: IVisaoGeral) => item.Descricao)))
                        .filter(Boolean)
                        .sort();

                    const uniqueChamados = Array.from(new Set(data.map((item: IVisaoGeral) => item.Chamado)))
                        .filter(Boolean)
                        .sort();

                    const uniqueComentadores = Array.from(new Set(data.map((item: IVisaoGeral) => item.UltimoComentarioUsuario)))
                        .filter(Boolean)
                        .sort();

                    const uniqueAssuntos = Array.from(new Set(data.map((item: IVisaoGeral) => item.Assunto)))
                        .filter(Boolean)
                        .sort();

                    const uniqueRequisitantes = Array.from(new Set(data.map((item: IVisaoGeral) => item.Requisitante)))
                        .filter(Boolean)
                        .sort();

                    const uniqueResponsaveis = Array.from(new Set(data.map((item: IVisaoGeral) => item.Responsavel)))
                        .filter(Boolean)
                        .sort();

                    // Atualiza as opções de filtro para cada coluna
                    console.log("🔄 Atualizando filtros das colunas...");

                    mainTableRef.current.updateColumnDefinition("Organization", {
                        headerFilterParams: {
                            values: uniqueOrganizations,
                            multiselect: true,
                            clearable: true,
                        },
                    });
                    console.log("✅ Organization - Valores únicos:", uniqueOrganizations.length, "itens");

                    mainTableRef.current.updateColumnDefinition("Local", {
                        headerFilterParams: {
                            values: uniqueLocais,
                            multiselect: true,
                            clearable: true,
                        },
                    });
                    console.log("✅ Local - Valores únicos:", uniqueLocais.length, "itens");

                    mainTableRef.current.updateColumnDefinition("LocalDescricao", {
                        headerFilterParams: {
                            values: uniqueLocalDescricoes,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    // Mapear valores para labels corretos quando for VWCO
                    const origemFilterValues = uniqueOrigens.map((origem: string) => {
                        if (origem === "Ativo" && isVwco) {
                            return { label: "Prisma", value: "Ativo" };
                        } else if (origem?.toLowerCase() === "gateway") {
                            return { label: "gateway", value: "gateway" };
                        } else {
                            return { label: origem, value: origem };
                        }
                    });

                    mainTableRef.current.updateColumnDefinition("Origem", {
                        headerFilterParams: {
                            values: origemFilterValues,
                            multiselect: true,
                            clearable: true,
                        },
                    });
                    console.log("✅ Origem - Valores únicos:", uniqueOrigens.length, "itens");

                    mainTableRef.current.updateColumnDefinition("Nome", {
                        headerFilterParams: {
                            values: uniqueNomes,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    mainTableRef.current.updateColumnDefinition("Descricao", {
                        headerFilterParams: {
                            values: uniqueDescricoes,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    mainTableRef.current.updateColumnDefinition("Chamado", {
                        headerFilterParams: {
                            values: uniqueChamados,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    mainTableRef.current.updateColumnDefinition("UltimoComentarioUsuario", {
                        headerFilterParams: {
                            values: uniqueComentadores,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    mainTableRef.current.updateColumnDefinition("Assunto", {
                        headerFilterParams: {
                            values: uniqueAssuntos,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    mainTableRef.current.updateColumnDefinition("Requisitante", {
                        headerFilterParams: {
                            values: uniqueRequisitantes,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    mainTableRef.current.updateColumnDefinition("Responsavel", {
                        headerFilterParams: {
                            values: uniqueResponsaveis,
                            multiselect: true,
                            clearable: true,
                        },
                    });

                    console.log("✅ Todos os filtros de colunas atualizados com sucesso!");
                }
            });

            // Função para atualizar o footerElement
            const updateFooter = (totalRows: number, filteredRows: number) => {
                const footer = document.getElementById("footer");
                if (footer) {
                    footer.innerHTML = `${totalRows.toLocaleString('pt-BR')} registros ${totalRows !== filteredRows ? `(${filteredRows.toLocaleString('pt-BR')} filtrados)` : ''}`;
                }
            };

            // Adicione o evento dataFiltered
            mainTableRef.current.on("dataFiltered", function (filters: any, rows: any[]) {
                console.log("🔍 Filtro aplicado - Linhas visíveis:", rows.length);
                updateFooter(listaVisaoGeral.length, rows.length);
                setRegistrosFiltrados(rows.length);
            });

            // Evento dataChanged para atualizações iniciais
            mainTableRef.current.on("dataChanged", function (data: any[]) {
                console.log("📊 Dados alterados - Total:", data.length);
                updateFooter(data.length, data.length);
                setRegistrosFiltrados(data.length);
            });

            // REMOVIDO: MutationObserver que estava causando problemas
            // O footer será controlado apenas pelos eventos do Tabulator

            // Adicionar evento para salvar filtros quando alterados
            mainTableRef.current.on("headerFilterChanged", function (headerValue: any, field: string) {
                // Log para debug
                console.log("🔧 Filtro alterado:", { field, headerValue });

                // Só salva filtros se a inicialização estiver completa
                if (!isInitialized || !urlFiltersApplied.current) {
                    console.log("🚫 Ignorando salvamento de filtro durante inicialização");
                    return;
                }

                try {
                    const allFilters = mainTableRef.current.getHeaderFilters();
                    const filtersObject = allFilters.reduce((acc: Record<string, any>, filter: any) => {
                        if (filter.value !== null && filter.value !== undefined && filter.value !== "") {
                            acc[filter.field] = filter.value;
                        }
                        return acc;
                    }, {});

                    // Incluir organizações selecionadas
                    filtersObject.selectedOrganizations = selectedOrganizations;

                    console.log("💾 Salvando filtros:", filtersObject);
                    setActiveFilters(filtersObject);
                    saveFiltersToStorage(filtersObject);
                } catch (error) {
                    console.error("❌ Erro ao salvar filtros:", error);
                }
            });

            // Aplicar filtros pendentes da URL - com delay maior para garantir inicialização completa
            setTimeout(() => {
                applyPendingUrlFilters();
            }, 500);

            // Só aplica os filtros salvos se não for refresh
            if (shouldApplyFilters) {
                applyStoredFilters();
            }
        })();
    }, [listaVisaoGeral, cacheUserId, colunasConfiguradas]);

    const limparFiltros = useCallback(() => {
        if (mainTableRef.current) {
            try {
                // Apenas limpa os filtros de cabeçalho do Tabulator.
                // Não altera dados, filtros globais ou localStorage.
                resetHeaderFilters();
                if (typeof mainTableRef.current.clearHeaderFilter === 'function') {
                    mainTableRef.current.clearHeaderFilter();
                }

                // Forçar atualização visual da tabela
                if (typeof mainTableRef.current.redraw === 'function') {
                    mainTableRef.current.redraw(true);
                }
            } catch (error) {
                console.error("Erro ao limpar filtros:", error);
            }
        }
    }, [resetHeaderFilters]);

    const handleDownloadCsv = () => {
        mainTableRef.current.download("csv", "visao_geral.csv");
    };

    const loadConfigTable = () => {
        if (!mainTableRef.current) {
            console.log("Tabela principal não inicializada");
            return;
        }

        console.log("Carregando configuração da tabela");

        const cols = mainTableRef.current
            .getColumns()
            .filter((col: ColumnComponent) => col.getField()) // Filtra apenas colunas com field definido
            .map((col: ColumnComponent, index: number) => {
                const def = col.getDefinition();
                console.log("Coluna encontrada:", {
                    field: col.getField(),
                    title: def.title,
                    visible: col.isVisible()
                });
                return {
                    id: index + 1,
                    title: def.title || col.getField(),
                    field: col.getField(),
                    visible: col.isVisible(),
                };
            });

        console.log("Total de colunas encontradas:", cols.length);

        if (configTableRef.current) {
            if (configTableRefInstance.current) {
                configTableRefInstance.current.destroy();
            }

            configTableRefInstance.current = new Tabulator(configTableRef.current, {
                data: cols,
                layout: "fitDataFill",
                movableRows: true,
                headerVisible: false,
                height: "calc(100vh - 200px)", // Altura ajustável
                rowFormatter: function (row) {
                    const data = row.getData();
                    // Oculta as 4 primeiras colunas (Situação, OrigemIcone, Status e Alerta)
                    if (data.id <= 4) {
                        row.getElement().style.display = "none";
                    }
                },
                columns: [
                    {
                        title: "Mover",
                        formatter: "handle",
                        headerSort: false,
                        width: 30,
                        minWidth: 30,
                    },
                    {
                        title: "Coluna",
                        field: "title",
                        formatter: (cell) => {
                            const data = cell.getRow().getData();
                            // Adiciona um indicador visual para colunas congeladas
                            if (data.id <= 4) {
                                return `<span style="color: #999;"><i class="ui icon lock"></i> ${cell.getValue()}</span>`;
                            }
                            return ` ${cell.getValue()}`;
                        },
                        width: 200,
                    },
                    {
                        title: "Visível",
                        field: "visible",
                        formatter: "tickCross",
                        editor: true,
                        width: 80,
                        hozAlign: "center",
                        editable: function (cell) {
                            // Desabilita edição para as 4 primeiras colunas
                            const data = cell.getRow().getData();
                            return data.id > 4;
                        }
                    },
                ],
            });
        }
    };

    const applyConfigChanges = async () => {
        const updatedCols = configTableRefInstance.current.getData();

        const allColumns = mainTableRef.current.getColumns();
        const frozenColumns = allColumns
            .slice(0, 4)
            .map((col: ColumnComponent) => col.getDefinition());

        const newColumns = updatedCols
            .map((col: any) => {
                const originalCol = mainTableRef.current.getColumn(col.field);
                if (originalCol) {
                    const definition = originalCol.getDefinition();
                    return {
                        ...definition,
                        visible: col.visible,
                    };
                }
                return col;
            })
            .slice(4);

        const finalColumns = [...frozenColumns, ...newColumns];

        mainTableRef.current.setColumns(finalColumns);

        // Persistir visibilidade e ordem no cache VISAO_GERAL
        const visibility: Record<string, boolean> = {};
        const order: string[] = [];
        mainTableRef.current.getColumns().forEach((col: ColumnComponent) => {
            const field = col.getField();
            if (field) {
                visibility[field] = col.isVisible();
                order.push(field);
            }
        });
        await saveTableColumnsCache(visibility, order);
    };

    return (
        <div className="d-flex" style={{ position: "relative" }}>
            <div style={{ width: sidebarVisible ? "calc(100% - 350px)" : "100%", transition: "0.3s" }}>
                <h1 className="ui header">Visão Geral</h1>
                <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
                    {/* ✅ NOVO - Filtros globais simplificados */}
                    <FiltroGlobal />

                    {/* Botões de ação */}
                    <button
                        onClick={() => {
                            setSidebarVisible(prev => {
                                const next = !prev;
                                // se estamos abrindo a sidebar, carregar a tabela de configuração
                                if (!prev) {
                                    setTimeout(() => {
                                        try {
                                            loadConfigTable();
                                        } catch (e) {
                                            console.error('Erro ao carregar configurações:', e);
                                        }
                                    }, 80);
                                }
                                return next;
                            });
                        }}
                        className="ui button primary"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                        <i className="ui icon cog"></i>
                        Configurações
                    </button>
                    <button
                        onClick={() => {
                            limparFiltros();
                            setSidebarVisible(false);
                        }}
                        className="ui button secondary"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                        <i className="ui icon trash alternate"></i>
                        Limpar Filtros
                    </button>
                    <button
                        onClick={handleDownloadCsv}
                        className="ui button secondary"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                        <i className="ui icon arrow alternate circle down outline"></i>
                        Download CSV
                    </button>
                    <button
                        onClick={() => obterVisaoGeral(selectedOrganizations)}
                        className="ui button secondary"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                        <i className="ui icon refresh"></i>
                        Atualizar
                    </button>
                </div>

                {/* Tabela */}
                <div ref={tableRef}></div>
            </div>

            {/* Sidebar de Configurações */}
            {sidebarVisible && (
        <div className="sidebar-config">

          {/* Botão de Fechar (X) com classe CSS */}
          <i
            className="ui icon close sidebar-close-btn"
            onClick={() => setSidebarVisible(false)}
            title="Fechar configurações"
          />

          {/* Header ajustado: Removido 'inverted' para controlar via CSS */}
          <h4 className="ui grey header sidebar-header">
            <i className="ui cog icon"></i> Configurações da Tabela
          </h4>

          <div className="config-content" ref={configTableRef}></div>

          <button className="ui primary button" onClick={applyConfigChanges}>
            <i className="ui save icon"></i> Aplicar
          </button>
        </div>
      )}
        </div>
    );
};

export default MenuVisaoGeral;